'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _index = require('../actions/index');

var actionCreators = _interopRequireWildcard(_index);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (config) {
  return function (WrappedComponent) {
    var ReduxDraft = function (_Component) {
      _inherits(ReduxDraft, _Component);

      function ReduxDraft() {
        _classCallCheck(this, ReduxDraft);

        return _possibleConstructorReturn(this, (ReduxDraft.__proto__ || Object.getPrototypeOf(ReduxDraft)).apply(this, arguments));
      }

      _createClass(ReduxDraft, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _props = this.props,
              _initialized = _props._initialized,
              init = _props.init;


          if (!_initialized) {
            init(config);
          }
        }
      }, {
        key: 'getChildContext',
        value: function getChildContext() {
          var _props2 = this.props,
              updateEditorState = _props2.updateEditorState,
              updateReadOnly = _props2.updateReadOnly,
              updateEntityData = _props2.updateEntityData,
              removeBlock = _props2.removeBlock;


          return {
            _reduxDraft: {
              updateEditorState: updateEditorState,
              updateReadOnly: updateReadOnly,
              updateEntityData: updateEntityData,
              removeBlock: removeBlock
            }
          };
        }
      }, {
        key: 'render',
        value: function render() {
          var _props3 = this.props,
              _instance = _props3._instance,
              name = _props3.name,
              config = _props3.config,
              editorState = _props3.editorState,
              customStyleMap = _props3.customStyleMap,
              rest = _objectWithoutProperties(_props3, ['_instance', 'name', 'config', 'editorState', 'customStyleMap']);

          return name !== undefined ? _react2.default.createElement(WrappedComponent, _extends({
            focus: (_instance || {}).focus,
            name: name,
            config: config,
            editorState: editorState,
            customStyleMap: customStyleMap
          }, rest)) : null;
        }
      }]);

      return ReduxDraft;
    }(_react.Component);

    ReduxDraft.childContextTypes = {
      _reduxDraft: _propTypes2.default.object
    };

    var mapStateToProps = function mapStateToProps(state) {
      var currentDraft = state.draft[config.name] || {};

      return currentDraft;
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
      var bindDraft = function bindDraft(actionCreator) {
        return actionCreator.bind(null, config.name);
      };
      var bondDraftActionCreators = {};

      Object.keys(actionCreators).forEach(function (ac) {
        bondDraftActionCreators[ac] = bindDraft(actionCreators[ac]);
      });

      return _extends({}, (0, _redux.bindActionCreators)(bondDraftActionCreators, dispatch), {
        dispatch: dispatch
      });
    };

    return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReduxDraft);
  };
};
//# sourceMappingURL=data:application/json;charset=utf8;base64,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



//////////////////
// WEBPACK FOOTER
// ../lib/components/reduxDraft.js
// module id = 587
// module chunks = 0